import React from 'react'
import { presenceSummary } from './presence.js'

/**
 * One-line banner above the composer: "Tamas is viewing this ticket" or,
 * louder, "Tamas is replying to this ticket".
 */
function PresenceBanner({ viewers }) {
  const summary = presenceSummary(viewers)
  if (!summary) return null
  return (
    <div
      role="status"
      className={`presence-banner${summary.composing ? ' presence-banner--composing' : ''}`}
    >
      {summary.label}
    </div>
  )
}

export default PresenceBanner
